import type { ContextualColor, SecondaryColor } from '@/components/sgBootstrapReactWrapper';
import { isDefined } from '@/utils/assertions';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

export const riskLevel = ['1', '2', '3', '4', '5'] as const;
export type RiskLevel = (typeof riskLevel)[number];

const colorForRisk: { [type in RiskLevel]: ContextualColor | SecondaryColor } = {
  '1': 'success', // low risk
  '2': 'warning', // med-low risk
  '3': 'danger', // med-high risk
  '4': 'danger', // high risk , 'danger' too according to mockups
  '5': 'danger', //
};

type Props = {
  risk: RiskLevel | null;
};

export const RiskBadge = ({ risk }: Props) =>
  isDefined(risk) ? (
    <span
      data-e2e="role-drawer-badge"
      className={clsx('badge', 'badge-md', 'rounded-pill', `badge-discreet-${colorForRisk[risk]}`)}
    >
      <FormattedMessage id={`person.amlLevel.${risk}`} />
    </span>
  ) : null;
